import React, { useEffect } from "react";
import { Card, Table, Layout, Form, Input, Space, Divider, Button, Radio, Badge, Col } from "antd";
import { observer } from "mobx-react";
import { articlesStore } from "../../store/content/article/ArticlesStore";
import { Link, useHistory, useLocation } from "react-router-dom";
import { FilterBar } from "../../components/filter/FilterBar";
import { ArticleDlg } from "./ArticleDlg";
import { fmtDateTime } from "../../common/Utils";
import { ArticlePublish } from "./ArticlePublish";
import { Toolbar } from "../../components/Toolbar";
import { PlusOutlined } from "@ant-design/icons";
import { SortOrder } from "antd/lib/table/interface";

export const Articles = observer(() => {
  const location = useLocation();
  const history = useHistory();
  const store = articlesStore;

  const onTab = (retired) => {
    const query = new URLSearchParams({ retired });
    history.push({
      search: query.toString(),
    });
  };

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    store.sortedInfo = sorter;
    store.refresh();
  };

  useEffect(() => {
    articlesStore.onLocation(location);
  }, []);

  useEffect(() => {
    articlesStore.onLocation(location);
  }, [location.search]);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Article Name",
      dataIndex: "title",
      key: "title.keyword",
      sorter: true,
      render: (v, r) => <a onClick={() => store.publishStore.show(r.id)}>{v}</a>,
      sortOrder: store.sortedInfo.columnKey === "title.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Content Type",
      dataIndex: "type",
      key: "type.keyword",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "type.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Article Status",
      dataIndex: "retired",
      key: "retired",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "retired" ? (store.sortedInfo.order as SortOrder) : undefined,
      render: (v) => (v ? "Retired" : "Active"),
    },
    {
      title: "Latest Edit Date",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: fmtDateTime,
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "updatedAt" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "",
      render: (_, r) => (
        <Space>
          <Link to={`/content/${r.id}/publishing`}>Publishing Records</Link>
          <Divider />
          <Badge count={r.unread} offset={[10, -4]}>
            <Link to={`/content/${r.id}/comments`}>Comments</Link>
          </Badge>
        </Space>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar
        actions={
          <Button type="primary" size="large" icon={<PlusOutlined />} onClick={() => store.editStore.show()}>
            New Article
          </Button>
        }
      >
        <Radio.Group size="large" value={store.filter.retired} onChange={(e) => onTab(e.target.value)}>
          <Radio.Button value={false}>Active</Radio.Button>
          <Radio.Button value={true}>Retired</Radio.Button>
        </Radio.Group>
      </Toolbar>

      <FilterBar store={store} actionsSpan={8}>
        <Col span={8}>
          <Form.Item label="Keyword">
            <Input value={store.filter.keyword} onChange={(e) => (store.filter.keyword = e.target.value)} />
          </Form.Item>
        </Col>
      </FilterBar>

      <Card size="small">
        <Table
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          onChange={onChange}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
        />
      </Card>
      {store.editStore.showDlg && <ArticleDlg />}
      {store.publishStore.showDlg && <ArticlePublish />}
    </Layout.Content>
  );
});
